import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'aid-textarea-input',
  template: `
    <div class="full-width full-height aid-layout-column aid-layout-gap-8">
      <mat-form-field class="full-height">
        <textarea
          matInput
          [maxlength]="maxLength"
          class="flex textarea"
          placeholder="{{ placeholder | translate | sentancecase }}"
          [formControl]="control"
          data-cy="textarea-input"
        >
        </textarea>

        @if (control.hasError('required')) {
          <mat-error>
            {{ 'this-field' | translate | titlecase }}
            {{ 'is-required' | translate }}
          </mat-error>
        }

        @for (error of control.errors | keyvalue; track error) {
          <mat-error>
            @if (displayError(error.key)) {
              {{ error.value | translate }}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  `,
  styleUrls: ['./textarea-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TextareaInputComponent implements OnInit {
  @Input({ required: true }) control = new UntypedFormControl();
  @Input() placeholder?: string;
  @Input() maxLength: number | null = null;

  @Output() write = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  displayError(error: string): boolean {
    return !(error === 'required');
  }
}
